import { axiosWithJWT } from '@/api/axiosWithJWT';

export const create = async (_, transaction) => {
  const { data } = await axiosWithJWT.post(
    '/api/CompanyTransaction/Create',
    transaction
  );
  return data;
};

export const getTransactionsByCompany = async (
  { commit },
  { companyId, params }
) => {
  const { data } = await axiosWithJWT.get(
    `/api/CompanyTransaction/GetListByCompany/${companyId}`,
    { params }
  );

  commit('storeLastTransactions', data.transactions);

  return data;
};

export const getTransactionStatus = async () => {
  const { data } = await axiosWithJWT.get('/api/TransactionStatus/GetList');
  return data;
};

export const getTransactionTypes = async () => {
  const { data } = await axiosWithJWT.get('/api/TransactionType/GetList');
  return data;
};

export const getTransactions = async (_, { params }) => {
  const { data } = await axiosWithJWT.get('/api/CompanyTransaction/GetList', {
    params,
  });
  return data;
};

export const updateTransaction = async (_, transaction) => {
  await axiosWithJWT.put(
    `/api/CompanyTransaction/Update/${transaction.id}`,
    transaction
  );
};

export const cancelTransaction = async (_, {transactionId, description}) => {
  await axiosWithJWT.put(
    `/api/CompanyTransaction/CancelTransaction/${transactionId}`,
    { description }
  );
};
